var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 18.7778V12.1111C7.66667 10.8838 6.67174 9.88889 5.44444 9.88889H3.22222C1.99492 9.88889 1 10.8838 1 12.1111V18.7778C1 20.0051 1.99492 21 3.22222 21H5.44444C6.67174 21 7.66667 20.0051 7.66667 18.7778ZM7.66667 18.7778V7.66667C7.66667 6.43937 8.66159 5.44444 9.88889 5.44444H12.1111C13.3384 5.44444 14.3333 6.43937 14.3333 7.66667V18.7778M7.66667 18.7778C7.66667 20.0051 8.66159 21 9.88889 21H12.1111C13.3384 21 14.3333 20.0051 14.3333 18.7778M14.3333 18.7778V3.22222C14.3333 1.99492 15.3283 1 16.5556 1H18.7778C20.0051 1 21 1.99492 21 3.22222V18.7778C21 20.0051 20.0051 21 18.7778 21H16.5556C15.3283 21 14.3333 20.0051 14.3333 18.7778Z",
    stroke: "#10A0B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.e10f741b.svg";
export { ForwardRef as ReactComponent };